import Service from '../service.js';

export default {
  components: {
  },
  data() {
    return {
      detail: {},
      id: '',
      count: true
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    if (this.$route.query && this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    this.getnewsDetail();
  },
  methods: {
    getnewsDetail() {
      Service.getnewsDetail({ id: this.id }).then(res => {

        this.detail = res;
        // console.log(this.detail, '1212');

      });
    }
  }
};
